export { default } from './multistore/storeCodeFromRoute'
